import React from "react";
import { Image } from "react-bootstrap";
import ModalWrapper from "../../../../../../components/ModalWrapper";

type Props = {
  show: boolean;
  imgPath: string;
  onHide: () => void;
};

const FullScreenImageModal: React.FC<Props> = ({ show, imgPath, onHide }) => (
  <ModalWrapper
    show={show}
    onHide={onHide}
    fullscreen
    showHeader={false}
    centered
    className="rl-cloud-sandbox-modal-transparent"
  >
    <div className="rl-cloud-sandbox-fullscreen-container" onClick={onHide}>
      <Image src={imgPath} />
    </div>
  </ModalWrapper>
);

export default FullScreenImageModal;
